import {Component} from '@angular/core';
import {LoginService} from './login.service';

@Component({
	selector: 'mmmi-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent {
	constructor(private readonly loginService: LoginService) {}

	get identity() {
		return this.loginService.id;
	}

	get name() {
		return this.loginService.name;
	}

	isLoggedIn(): boolean {
		return this.loginService.id != null;
	}

	async login() {
		await this.loginService.login();
	}

	async logout() {
		await this.loginService.logout();
	}
}
